import * as React from 'react';
import {Tooltip} from '@mui/material';
import {Button} from '@material-ui/core';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper'; 
import ActivitySave from './ActivitySave';
import LogCallsActivitySave from './LogCallsActivitySave';
import DeleteAlert from '../components/DeleteAlert';
import Alert from '../components/Alert';
import {API_URL} from '../utils/EnvVars';
import axios from 'axios';
import {Edit} from '@mui/icons-material';


export default function BasicTable(props) {
  const childRefActivitySave = React.useRef();
  const childRefLogCallActivitySave = React.useRef();
  const childRefAlert = React.useRef();  
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [alertMessage, setAlertMessage] = React.useState("");

  const [rows, setRows] = React.useState([]);
  const [dataObj, setDataObj] = React.useState({});

  React.useEffect(() => {
    setRows(props.rows);
  }, [props.rows]);

  function add() { 
      setDataObj({});
      childRefActivitySave.current.handleClickOpen();
  }
  function logACall() {
    childRefLogCallActivitySave.current.handleClickOpen();
  }

  function edit(obj) { 
      setDataObj(obj);
      childRefActivitySave.current.handleClickOpen();
  }

  function updatedList(list){
      setRows(list);
      props.activitiesUpdatedList(list);
  }


	function deleteNow(obj){
		if(obj && obj!=null && props.userObj){
			let apiUrl=API_URL+'/crm-delete-activity';
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': props.userObj.registerId,
					'uid': props.userObj.loginId,
					'fullName': props.userObj.fullName,
					'token': props.userObj.token,
				}
			};
  
		  const data = new FormData();
		  data.append('id', obj.autoId);				 
      data.append('relatedTo', props.relatedTo);
      data.append('relatedToId', props.relatedToId);
      data.append('relatedTitle', props.relatedTitle);

		  axios.post(apiUrl, data, axiosHeader)
				.then((response) => {
					///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
          setSeverityAlert("success");					
					setAlertMessage("Activity has been deleted.");
          childRefAlert.current.handleClickOpen();
          setRows(response.data.list);
					return false;
				}else{
			  	setSeverityAlert("error");
					setAlertMessage("Activity could not be deleted.");		
          childRefAlert.current.handleClickOpen();	
					return false;
				}
			})
			.catch((error) => {
          setSeverityAlert("error");
					setAlertMessage(" "+error);		
          childRefAlert.current.handleClickOpen();	
					return false;
			})	
		}		
	
		
	}


  return (<>
    {(props.privilegesActivities && props.privilegesActivities.indexOf("create")>-1)?
      <div style={{textAlign:'center',marginBottom:10}}>
          <Button onClick={() => {add()}} style={{textTransform:'none',maxHeight:25, marginRight: 10}} size="small" variant="outlined" >Add Activity</Button>
          <Button onClick={() => {logACall()}} style={{textTransform:'none',maxHeight:25}} size="small" variant="outlined" >Log a Call</Button>
      </div>
    :null}  
      
    <TableContainer component={Paper}>
      <Table sx={{ width: '100%' }} aria-label="simple table">        
        <TableBody>
          {rows?rows.map((row) => (
            <TableRow
              key={row.autoId}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >  
              <TableCell>

              {row.activityType==='Call'?<><i className="fa fa-phone" style={{fontSize:15}} ></i></>:row.activityType==='Email'?<><i className="fa fa-envelope" style={{fontSize:15}} ></i></>:row.activityType==='Meeting'?<><i className="fa fa-clock-o" style={{fontSize:15}} ></i></>:row.activityType==='WhatsApp'?<><i className="fa fa-whatsapp" style={{fontSize:15}} ></i></>:<><i className="fa fa-globe" style={{fontSize:15}} ></i></>}
              
              <span style={row.status==='Open'?{marginLeft:5, fontWeight:'bold'}:{marginLeft:5}} >{row.subject}</span>
              
              {row.status==='Open'?<>
                <Chip label={row.status} size="small" color="success" style={{marginLeft:10, fontSize:11, padding:0}} />
                <span style={{marginLeft:10}} >
                  {(props.privilegesActivities && ((props.privilegesActivities.indexOf("update")>-1 && props.userObj.userId===row.ownerId) || props.privilegesActivities.indexOf("modifyall")>-1) )?
                    <Tooltip title={'Edit, Last Modified By: '+row.lastModifiedAlias+', '+row.lastModifiedDateTime} arrow>
                        <Edit className='iconGraySmall' onClick={()=>{edit(row)}}  />
                    </Tooltip>
                  :null}
                  {(props.privilegesActivities && props.privilegesActivities.indexOf("delete")>-1)?
                    <DeleteAlert deleteNow={deleteNow} dataObj={row} text={'Are you sure, You want to delete activity.'} className='iconGraySmall' />
                  :null}  
                </span>
              </>:null}

              {(row.remarks && row.remarks.length>0)?<><br/>{row.remarks}</>:null}
              
              {row.status==='Open'?<>
                <br/><b>{row.activityType} Date: {row.startDateTime}</b>
                <br/>Priority: {row.priority}
              </>:null}

              <br/><small>Created By: {row.createdAlias} {row.lastModifiedDateTime}</small>
              <br/>

              </TableCell>

            </TableRow>
          )):null}
        </TableBody>
      </Table>
    </TableContainer>
    
    {(!rows || rows.length<1)?<div className='nrfbox'>No activity found</div>:null}  

    <ActivitySave activityForVisible={props.activityForVisible} dataObj={dataObj} relatedTo={props.relatedTo} relatedToId={props.relatedToId} accountId={props.accountId} relatedTitle={props.relatedTitle} updatedList={updatedList} userObj={props.userObj} ref={childRefActivitySave} />
    <LogCallsActivitySave activityForVisible={props.activityForVisible} relatedTo={props.relatedTo} relatedToId={props.relatedToId} accountId={props.accountId} relatedTitle={props.relatedTitle} updatedList={updatedList} userObj={props.userObj} ref={childRefLogCallActivitySave} />
              
    
    <Alert severityAlert={severityAlert} alertMessage={alertMessage} ref={childRefAlert} />          

  </>);
}
